import state from "./moduleTeamsState.js";
import mutations from "./moduleTeamsMutations.js";
import actions from "./moduleTeamsActions.js";
import getters from "./moduleTeamsGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
